import { render, staticRenderFns } from "./UtilityCalculator.vue?vue&type=template&id=08b522bc&scoped=true&"
import script from "./UtilityCalculator.vue?vue&type=script&lang=js&"
export * from "./UtilityCalculator.vue?vue&type=script&lang=js&"
import style0 from "./UtilityCalculator.vue?vue&type=style&index=0&id=08b522bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b522bc",
  null
  
)

export default component.exports